import { atomWithStorage } from 'jotai/utils';
export type ProjectProps = {
  id: string;
  name: string;
} | null;

export const projectAtom = atomWithStorage<ProjectProps>('project', null);
